import { FiFileText } from 'react-icons/fi';
import type { orderFinancials } from './financials';
import type { Label, Translate } from './messages';
import * as s from './styles';

export default function OrderFinancialSummary({
  totals,
  l,
  money,
  decimal,
}: {
  totals: ReturnType<typeof orderFinancials>;
  l: Translate;
  money: (value: unknown) => string;
  decimal: (value: unknown) => string;
}) {
  const rows: {
    label: Label;
    amount: number | null;
    percent: number | null;
    after?: number | null;
  }[] = [
    {
      label: 'discountItems',
      amount: totals.itemDiscount,
      percent: totals.itemPercent,
      after: totals.itemsNet,
    },
    {
      label: 'discountGeneral',
      amount: totals.generalDiscount,
      percent: totals.generalPercent,
      after: totals.calculatedNet,
    },
    { label: 'discountTotal', amount: totals.totalDiscount, percent: totals.totalPercent },
  ];
  return (
    <s.Card>
      <h3>
        <FiFileText size={18} aria-hidden="true" />
        {l('financialSummary')}
      </h3>
      <s.FinancialPanel>
        <div className="financial-line">
          <span>{l('subtotal')}</span>
          <strong>{money(totals.gross)}</strong>
        </div>
        {rows.map((row) => (
          <div className="financial-line compact" key={row.label}>
            <span>{l(row.label)}</span>
            <div>
              <strong className="discount">
                {row.percent === null ? '' : `(${decimal(row.percent)}%) `}
                {money(row.amount)}
              </strong>
              {row.after !== undefined && row.after !== null && (
                <small>
                  {l('afterDiscount')}: {money(row.after)}
                </small>
              )}
            </div>
          </div>
        ))}
        {!!totals.surcharge && (
          <div className="financial-line">
            <span>{l('surcharge')}</span>
            <strong className="surcharge">+ {money(totals.surcharge)}</strong>
          </div>
        )}
        <div className="financial-total">
          <span>{l('orderTotal')}</span>
          <strong>{money(totals.net)}</strong>
        </div>
      </s.FinancialPanel>
    </s.Card>
  );
}
